import type { IconData } from '@stacksjs/iconify-core'

export const house: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M408 406.545V248H288v158.545ZM320 280h56v94.545h-56Z\"/><path fill=\"currentColor\" d=\"M271.078 33.749a34 34 0 0 0-47.066.984L32 226.745V496h112V336h64v160h272V225.958ZM448 464H240V304H112v160H64V240L249.412 57.356V57.3L448 240Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default house
